<!-- 
Dialog for clearing a levy collection.

This is a testing tool and will not be available in production.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>Clear data from a levy collection</v-toolbar-title>
      </v-toolbar>
      <our-busy-indicator :show="clearing"/>
      <v-card-text v-if="isSignedIn">
        <p v-if="levyCollectionId == null">Choose the levy collection that you want to clear:</p>
        <levy-collection-listing v-if="levyCollectionId == null" ref="listing" @click="select"/>
        <p v-if="levyCollectionId != null">
          Clear the in-scope providers, overrides, notices, invoices and history from the 
          <strong>{{ levyCollection.year }} {{ lookups.levyCollectionTypeDescriptions[levyCollection.type] }}</strong>
          levy collection?
          This action cannot be undone.
        </p>
      </v-card-text>
      <v-alert v-else :value="true" type="info">
        You need to be signed in to use this function.
      </v-alert>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="clearing" flat @click="hide">Cancel</v-btn>
        <v-btn 
          :disabled="clearing || levyCollectionId == null"
          flat color="error" 
          @click="clear"
        >
          Clear levy collection
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as action from "@/store/system/action-types";
import lookupMixins from "@/mixins/lookup.mixins";
import LevyCollectionListing from "@/components/levy-collections/LevyCollectionListing.vue";

export default {
  components: { LevyCollectionListing },
  mixins: [lookupMixins],
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      levyCollectionId: null,
      levyCollection: null
    };
  },
  computed: {
    state() {
      return this.$store.state.system.clearProviders;
    },
    clearing() {
      return this.state.clearing;
    },
    isSignedIn() {
      return this.$store.getters.isSignedIn;
    }
  },
  watch: {
    show(nowShowing) {
      if (nowShowing) {
        this.levyCollectionId = null;
        this.levyCollection = null;
      }
    }
  },
  methods: {
    async clear() {
      await this.$store.dispatch(action.CLEAR_LEVY_COLLECTION, this.levyCollectionId);
      this.hide();
    },
    hide() {
      this.$emit("update:show", false);
    },
    select(levyCollectionId, levyCollection) {
      this.levyCollectionId = levyCollectionId;
      this.levyCollection = levyCollection;
    }
  }
};
</script>
